import { render, staticRenderFns } from "./AdministracionTratamientos.vue?vue&type=template&id=14493264&scoped=true"
import script from "./AdministracionTratamientos.vue?vue&type=script&lang=js"
export * from "./AdministracionTratamientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14493264",
  null
  
)

export default component.exports